module.exports = __webpack_public_path__ + "static/media/1020137.5d80d21e.png";